import VehiclesGroupedReport from "./VehiclesGroupedReport";

export default function VehiclesByCountry() {
  return (
    <VehiclesGroupedReport
      title="Vehicles by Country"
      subtitle="Active fuel access registrations grouped by the country of the user's retail outlet."
      dimension="country"
      dropdownLabel="Country"
      dropdownPlaceholder="All countries"
      dropdownApiPath="/master/countries"
    />
  );
}
